import React from 'react';

/**
 * Loader.
 */
const Loader = (): JSX.Element => {
  return (
    <div className="loader">
      <div className="loader-icon"></div>
    </div>
  );
};
export default Loader;
